import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { gql } from '@apollo/client';
import { Button, Input } from 'reactstrap';
import { Routes } from '@/utils/routes';
import i18n from '@/utils/i18n';
import { InvoiceCollectionScope } from '@/graphql/generatedTypes';

export const CREATE_INVOICE_COLLECTION = gql`
  mutation CreateInvoiceCollection($item: CreateInvoiceCollection!) {
    createInvoiceCollection(item: $item) {
      id
    }
  }
`;

function CreateInvoiceCollectionButton() {
  const history = useHistory();
  const [scope, setScope] = useState<InvoiceCollectionScope>(
    InvoiceCollectionScope.All,
  );
  const [createInvoiceCollection, { loading, error }] = useMutation(
    CREATE_INVOICE_COLLECTION,
    {
      onCompleted: (data) => {
        // Navigate to the new Invoice Collection page on successful creation
        history.push(Routes.invoiceCollection(data.createInvoiceCollection.id));
      },
    },
  );

  const handleCreate = () => {
    createInvoiceCollection({
      variables: {
        item: { name: i18n.t('Common:newInvoiceCollection'), scope },
      },
    });
  };

  return (
    <div>
      <div className="d-flex align-items-center gap-2">
        <Input
          type="select"
          aria-label={i18n.t('InvoiceCollection:scope')}
          title={i18n.t('InvoiceCollection:scopeImmutableHint')}
          value={scope}
          onChange={(e) => setScope(e.target.value as InvoiceCollectionScope)}
          style={{ width: 'auto' }}
        >
          <option value={InvoiceCollectionScope.All}>
            {i18n.t('InvoiceCollection:scopeAll')}
          </option>
          <option value={InvoiceCollectionScope.PenaltyBillsOnly}>
            {i18n.t('InvoiceCollection:scopePenaltyBillsOnly')}
          </option>
        </Input>
        <Button variant="primary" onClick={handleCreate} disabled={loading}>
          {i18n.t('Common:createNewInvoiceCollection')}
        </Button>
      </div>
      {loading && <p>{i18n.t('Common:creating')}</p>}
      {error && <p>Error: {error.message}</p>}
    </div>
  );
}

export default CreateInvoiceCollectionButton;
